import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 24, fontFamily: "sans-serif", background: "#0B1E33", color: "#fff", textAlign: "center" }} data-testid="app-error-fallback">
        <div>
          <div style={{ fontSize: 20, fontWeight: 700, marginBottom: 8 }}>Halaman gagal dimuat</div>
          <div style={{ fontSize: 14, opacity: 0.8, marginBottom: 16 }}>Matikan fitur terjemahan otomatis browser, lalu muat ulang halaman.</div>
          <button type="button" onClick={() => window.location.reload()} style={{ background: "#F04E23", color: "#fff", border: 0, borderRadius: 999, padding: "10px 22px", fontSize: 14, fontWeight: 600 }} data-testid="app-error-reload">Muat Ulang</button>
          <div style={{ fontSize: 11, opacity: 0.5, marginTop: 16, wordBreak: "break-word" }}>{String(this.state.error?.message || this.state.error)}</div>
        </div>
      </div>
    );
  }
}
